module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.song.title),
      expression: "song.title"
    }],
    staticClass: "input title",
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.song.title)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.song, "title", $event.target.value)
      }, function($event) {
        return _vm.update('title', $event.target.value)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-taginput', {
    attrs: {
      "ellipsis": "",
      "placeholder": "Add a tag",
      "icon": "label",
      "autocomplete": "",
      "data": _vm.displayedTags,
      "field": "name"
    },
    on: {
      "input": function($event) {
        return _vm.update('song.tags', $event)
      },
      "typing": _vm.getFilteredTags
    },
    model: {
      value: (_vm.song.song.tags),
      callback: function($$v) {
        _vm.$set(_vm.song.song, "tags", $$v)
      },
      expression: "song.song.tags"
    }
  })], 1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.song.lyrics),
      expression: "song.lyrics"
    }, {
      name: "autosize",
      rawName: "v-autosize"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Lyrics"
    },
    domProps: {
      "value": (_vm.song.lyrics)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.song, "lyrics", $event.target.value)
      }, function($event) {
        return _vm.update('lyrics', $event.target.value)
      }]
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0911fcfe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SongEdit.vue
// module id = 310
// module chunks = 2